import axiosInstance from "auth/FetchInterceptor";
import {
  GET_MISA_ACCOUNT_OBJECTS,
  GET_MISA_INVENTORY_ITEMS,
  GET_MISA_STOCKS,
  GET_MISA_UNITS,
  GET_MISA_BANK_ACCOUNTS,
  GET_MISA_ORGANIZATION_UNITS,
  GET_MISA_INVENTORY_CATEGORIES,

  SAVE_MISA_ACCOUNT_OBJECTS,
  SAVE_MISA_INVENTORY_ITEMS,
  SAVE_MISA_STOCKS,
  SAVE_MISA_UNITS,
  SAVE_MISA_BANK_ACCOUNTS,
  SAVE_MISA_ORGANIZATION_UNITS,
  SAVE_MISA_INVENTORY_CATEGORIES,
  MISA_SYNC_DATA,
  MISA_RETRY_SYNC_DATA
} from "constants/ApiConstant";

const MisaService = {};

MisaService.getAccountObjects = function (params) {
  return axiosInstance.get(GET_MISA_ACCOUNT_OBJECTS, { params });
};

MisaService.getInventoryItems = function (params) {
  return axiosInstance.get(GET_MISA_INVENTORY_ITEMS, { params });
};

MisaService.getStocks = function (params) {
  return axiosInstance.get(GET_MISA_STOCKS, { params });
};

MisaService.getUnits = function (params) {
  return axiosInstance.get(GET_MISA_UNITS, { params });
};

MisaService.getBankAccounts = function (params) {
  return axiosInstance.get(GET_MISA_BANK_ACCOUNTS, { params });
};

MisaService.getOrganizationUnits = function (params) {
  return axiosInstance.get(GET_MISA_ORGANIZATION_UNITS, { params });
};

MisaService.getInventoryCategories = function (params) {
  return axiosInstance.get(GET_MISA_INVENTORY_CATEGORIES, { params });
};

MisaService.saveAccountObjects = function (payload) {
  return axiosInstance.post(SAVE_MISA_ACCOUNT_OBJECTS, payload);
};

MisaService.saveInventoryItems = function (payload) {
  return axiosInstance.post(SAVE_MISA_INVENTORY_ITEMS, payload);
};

MisaService.saveStocks = function (payload) {
  return axiosInstance.post(SAVE_MISA_STOCKS, payload);
};

MisaService.saveUnits = function (payload) {
  return axiosInstance.post(SAVE_MISA_UNITS, payload);
};

MisaService.saveBankAccounts = function (payload) {
  return axiosInstance.post(SAVE_MISA_BANK_ACCOUNTS, payload);
};

MisaService.saveOrganizationUnits = function (payload) {
  return axiosInstance.post(SAVE_MISA_ORGANIZATION_UNITS, payload);
};

MisaService.saveInventoryCategories = function (payload) {
  return axiosInstance.post(SAVE_MISA_INVENTORY_CATEGORIES, payload);
};

MisaService.syncData = function (payload) {
  return axiosInstance.post(MISA_SYNC_DATA, payload);
};

MisaService.syncRetry = function (logId) {
  return axiosInstance.post(`${MISA_RETRY_SYNC_DATA}/${logId}`);
};
export default MisaService;